import { useState, useEffect } from "react";
import styled from "styled-components";
import ModalUpdatePlan from "./modalUpdatePlan";
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

const Title = styled.div`
    position: relative;
    width: 100%;
    min-height: 56px;
    background-color: #463694;
    z-index: 1000;
    display: flex;
    align-items: center;
    padding: 8px 40px;

    @media (max-width: 700px) {
        flex-direction: column;
        gap: 16px;
        max-height: 156px;
    }
`;

const Container = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    gap: 8px;

    @media (max-width: 700px) {
        flex-direction: column;
        gap: 16px;
    }
`;

const ContainerText = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;

    @media (max-width: 700px) {
        svg {
            display: none;
        }
    }
`;

const Text = styled.span`
    color: #FFF;
    font-family: Montserrat;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
    letter-spacing: -0.56px;

    @media (max-width: 700px) {
        font-size: 12px;
    }
`;

const HighlightedText = styled.span`
    color: #FFF;
    font-family: Montserrat;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 150%;
    letter-spacing: -0.56px;

    @media (max-width: 700px) {
        font-size: 12px;
        text-align: center;
    }
`;

const ButtonNewPlan = styled.button`
    display: flex;
    height: 40px;
    padding: 12px 16px;
    justify-content: center;
    align-items: center;
    gap: 8px;
    border-radius: 8px;
    background: #FFCF3D;
    border: none;
    cursor: pointer;

    @media (max-width: 700px) {
        width: 100%;
    }
`;

const ButtonText = styled.span`
    color: var(--Dark-Pure, #000);
    text-align: center;
    font-family: Montserrat;
    font-size: 12px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px;
    text-transform: uppercase;
`;

const ToastUpdatePlan = () => {
    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
        const hasSeenUpdatePlanModal = localStorage.getItem('hasSeenUpdatePlanModal');

        if (!hasSeenUpdatePlanModal) {
            setShowModal(true);
            localStorage.setItem('hasSeenUpdatePlanModal', 'true');
        }
    }, []);

    return (
        <>
            <Title>
                <Container>
                    <ContainerText>
                        <ErrorOutlineIcon fontSize="small" style={{ fill: '#FFF' }} />
                        <HighlightedText>
                         Novos preços no Zag: <Text>Conheça nossos novos planos para 2026 e continue descomplicando os reembolsos corporativos da sua empresa.</Text>
                        </HighlightedText>
                    </ContainerText>
                    <ButtonNewPlan onClick={() => setShowModal(true)}>
                        <ButtonText>Conhecer os novos planos</ButtonText>
                    </ButtonNewPlan>
                </Container>
            </Title>
            <ModalUpdatePlan showModal={showModal} setShowModal={setShowModal} />
        </>
    );
};

export default ToastUpdatePlan;
